import { FigmaFileStructureNode, FigmaFileStructureStatistics, } from "./data/figma-file-structure";
import { DesignElementBase } from "./base";
import { z } from "zod";
export const FigmaFileStructureOrigin = z.object({
    sourceId: z.string(),
    fileId: z.string().optional(),
});
export const FigmaFileStructureData = z.object({
    rootNode: FigmaFileStructureNode,
    assetsInFile: FigmaFileStructureStatistics,
});
export const FigmaFileStructure = DesignElementBase.extend({
    origin: FigmaFileStructureOrigin,
    data: FigmaFileStructureData,
});
export function traverseStructure(node, action) {
    action(node);
    for (const child of node.children) {
        traverseStructure(child, action);
    }
}
